import "./Home.css"
import a from "/Users/nikkylu/lumed/src/pages/components/premium/a.jpg"
import b from "/Users/nikkylu/lumed/src/pages/components/premium/b.jpg"
import c from "/Users/nikkylu/lumed/src/pages/components/premium/c.jpg"
import d from "/Users/nikkylu/lumed/src/pages/components/premium/d.jpg"
import e from "/Users/nikkylu/lumed/src/pages/components/premium/e.jpg";
import f from "/Users/nikkylu/lumed/src/pages/components/premium/f.jpg";
import g from "/Users/nikkylu/lumed/src/pages/components/premium/g.jpg";
import h from "/Users/nikkylu/lumed/src/pages/components/premium/h.png";
import i from "/Users/nikkylu/lumed/src/pages/components/premium/i.jpg";
import j from "/Users/nikkylu/lumed/src/pages/components/premium/j.jpg";
import k from "/Users/nikkylu/lumed/src/pages/components/premium/k.jpg";
import l from "/Users/nikkylu/lumed/src/pages/components/premium/l.jpg";
import m from "/Users/nikkylu/lumed/src/pages/components/premium/m.jpg";
import n from "/Users/nikkylu/lumed/src/pages/components/premium/n.jpg";
import o from "/Users/nikkylu/lumed/src/pages/components/premium/o.jpg";
import p from "/Users/nikkylu/lumed/src/pages/components/premium/p.jpg";
import { Link } from 'react-router-dom';

const Premium = () => {
  return (
<div className="Home">
    <div>New Premium Quality Recommended</div>
    <div className="Home-con">
        <img src={a} className="Home-sp"/>
        <div className="Home-s">
            <div>Latex Surgical Gloves, sterile, EN 455 / ASTM 3577, </div>
            <div>premium quality, CE</div>
            <div>powder free or pre-powdered, anatomic shaped,</div>
            <div>rough surface, usual or dry type</div>
            <div>size: 6, 6 1/2, 7, 7 1/2, 8, 8 1/2, 9</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={b} className="Home-sp"/>
        <div className="Home-s">
            <div>Latex Condoms, ISO 4074:2015, CE </div>
            <div>smooth surface / ribbed surface </div>
            <div>/ dotted surface with or without scent</div>
            <div>size: 49 +/-2mm, 53+/-2mm, 55+/-2mm</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={c} className="Home-sp"/>
        <div className="Home-s">
            <div>Foley Balloon Catheter, sterile, CE</div>
            <div>Latex (or silicone), but silicone coated, various sizes</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={d} className="Home-sp"/>
        <div className="Home-s">
            <div>Plaster Of Pairs Bandage, BP, premium quality, CE </div>
            <div>Size: 5cm / 7.5cm / 10cm /12.5cm / 15cm / 20cm x 2.7m / 3m / 4.5m</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={f} className="Home-sp"/>
        <div className="Home-s">
            <div>Mercury-Free Oval Thermometers, ISO12470-1, premium quality</div>
            <div>big type, C-scale or C & F – scale</div>
        </div>
    </div>


    <div className="Home-con">
        <img src={g} className="Home-sp"/>
        <div className="Home-s">
            <div>Disposable Wound Dressings, sterile, CE</div>
            <div>various sizes, non-woven or transparent film, with wound pad</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={h} className="Home-sp"/>
        <div className="Home-s">
            <div>Disposable Safety Syringes, sterile, CE, various sizes</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={i} className="Home-sp"/>
        <div className="Home-s">
            <div>Disposable Needles, sterile, ISO 7864, CE</div>
            <div>usual / safety type, with or without filter, various sizes</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={j} className="Home-sp"/>
        <div className="Home-s">
            <div>Scalp Vein Set, sterile, ISO 8536/4, CE</div>
            <div>usual / safety type, various sizes</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={k} className="Home-sp"/>
        <div className="Home-s">
            <div>Single-Use Insulin Syringes, sterile, ISO 8537, CE</div>
            <div>0.3ml, 0.5ml, 1ml, U-100 or U-40, with integrated needle</div>
            <div>1ml, U-100 or U-40, with mounted needle</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={l} className="Home-sp"/>
        <div className="Home-s">
            <div>Disposable Syringe, sterile, ISO 7886, CE</div>
            <div>1ml, luer-lock</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={m} className="Home-sp"/>
        <div className="Home-s">
            <div>Endotracheal Tubes, sterile, CE</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={n} className="Home-sp"/>
        <div className="Home-s">
            <div>Tracheotomy Tube, sterile, CE, various sizes</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={o} className="Home-sp"/>
        <div className="Home-s">
            <Link to="/Device">
            Various Device Kits
            </Link>
            <div>Please refer to this section for details.</div>
        </div>
    </div>

    <div className="Home-con">
        <img src={p} className="Home-sp"/>
        <div className="Home-s">
            <Link to="/Dressing">Various Device & Dressing Kits.</Link>
            <div>Please refer to this section for details.</div>
        </div>
    </div>

    </div>

  )
}

export default Premium;